export const validateStagingLaneBarcode = (barcode: string) => /^ILN\w{10}$/gi.test(barcode);
